import { cisStatic } from '../../cisService/api';
import Cookies from 'js-cookie';

const suv = Cookies.get('SUV') || '';
const spm = "smpc.home-classic.top-festival";
const params = {
  clientType: 3,
  pvId: suv,
  requestId: genRequestId(),
  refererSpm: spm,
  refererPath: window.location.pathname,
  referSpm: getQueryString('spm') || '',
  referPath:window.document.referrer ? '/' + window.document.referrer.replace(/\?+[^?]*$/,'').split('/').slice(3).join('/') : '',
  sceneParam:[{
    page: 1,
    size: 10,
    spm: spm,
  }]
}

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return '';
}

function genRequestId() {
  var rands = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var arr = new Array(7);
  for (var i = 0; i < arr.length; i++) {
    arr[i] = rands[parseInt(Math.random() * rands.length, 0)];
  }
  var requestId = Date.now() + '_' + arr.join('');
  return requestId;
}

function minFestival() {
  cisStatic(params).then(res => {
    const data = res["smpc.home-classic.top-festival"].data[0].resourceData.data.content[0];
    const bg = data.bg;
    const start = data.startTime;
    const end = data.endTime;
    if (+new Date() > (new Date(start).getTime()) && +new Date() < (new Date(end).getTime())) {
      document.querySelector('.input_SearchInput').style.width='257px';
      document.querySelector('.input_SearchInput').style.marginLeft='163px';
      document.querySelector('.searchBox_HomeSearchBox').style.background='#fff url(' + bg + ') no-repeat';
      document.querySelector('.searchBox_HomeSearchBox').style.backgroundSize='contain';
    }
  })
}
export default minFestival;


// WEBPACK FOOTER //
// ./src/JS/cisFeed/festival.js